import Dropdown from './dropdown';
import DropdownButton from './dropdown-button';
import DropdownNormal from './dropdown-normal';

Dropdown.DropdownButton = DropdownButton;
Dropdown.DropdownNormal = DropdownNormal;
export default Dropdown;
